import { render, staticRenderFns } from "./FormSubscription.vue?vue&type=template&id=b23ecf00&scoped=true"
import script from "./FormSubscription.vue?vue&type=script&lang=js"
export * from "./FormSubscription.vue?vue&type=script&lang=js"
import style0 from "./FormSubscription.vue?vue&type=style&index=0&id=b23ecf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23ecf00",
  null
  
)

export default component.exports